import { render, staticRenderFns } from "./Profil.vue?vue&type=template&id=c832a8ea&scoped=true"
import script from "./Profil.vue?vue&type=script&lang=js"
export * from "./Profil.vue?vue&type=script&lang=js"
import style0 from "./Profil.vue?vue&type=style&index=0&id=c832a8ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c832a8ea",
  null
  
)

export default component.exports